import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { IncoTermService } from '../../../../shared/services/inco-term.service';

@Component({
    selector: 'app-inco-terms',
    templateUrl: './inco-terms.component.html',
    styleUrls: ['./inco-terms.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class IncoTermsComponent implements OnInit {

  constructor(private incoTermService:IncoTermService,private router: Router) { }

  INCOList:any;
  INCOSelectedListItem:any = 'deafult';
  INCOListDestailsheader:any = [];
  INCOListDestailsBody:any = [];
  isLoader:boolean = false;
  ngOnInit(): void {
    this.incoTermService.getINCOList().subscribe((res)=>{
           this.INCOList = res;
          // console.log(this.INCOList);
    })
  }
  
  pro1Width:any = 0;
  pro2Width:any = 0;
  onINCOChange(){

    this.pro1Width = '0px';
    this.pro2Width = '0px';

    switch (this.INCOSelectedListItem) {
      case '1':
        this.pro1Width = '92px';
        this.pro2Width = '92px';
        break;
        case '2':
          this.pro1Width = '175px';
          this.pro2Width = '175px';
          break;
          case '3':
            this.pro1Width = '255px';
            this.pro2Width = '255px';
            break;
            case '4':
              this.pro1Width = '345px';
              this.pro2Width = '345px';
              break;
              case '5':
                this.pro1Width = '175px';
                this.pro2Width = '510px';
                break;
                case '6':
                  this.pro1Width = '340px';
                  this.pro2Width = '425px';
                  break;
                case '7':
                    this.pro1Width = '340px';
                    this.pro2Width = '425px';
                    break;
                    case '8':
                      this.pro1Width = '165px';
                      this.pro2Width = '515px';
                      break;
                      case '9':
                        this.pro1Width = '515px';
                        this.pro2Width = '515px';
                        break;
                        case '10':
                          this.pro1Width = '515px';
                          this.pro2Width = '515px';
                          break;
                          case '11':
                            this.pro1Width = '515px';
                            this.pro2Width = '515px';
                            break;
      default:
        break;
    }


    let ob = {
      termID:this.INCOSelectedListItem
    }
    this.isLoader = true;
    this.incoTermService.getINCODetails(ob).subscribe((res)=>{
         this.INCOListDestailsBody = res.incosettings;
         this.INCOListDestailsheader = res.incodetails;
         this.isLoader = false;
    },(error)=>{
      this.isLoader = false;
    })
  }

  navigate(e:any){
    this.router.navigate(["/contact"]);
  }

}
